import React from 'react'
import HostLink from './HostLink'

/**
 * The brand block at the top of the chrome-less pages: signup, sign in and
 * password reset. App.jsx keeps both navbars off these routes on purpose, and
 * until 2026-10-16 that left a visitor who clicked "Start free trial" with no
 * way back to the marketing site except the browser's Back button.
 *
 * Two links home, deliberately. The logo is the convention people try first;
 * the text link is the one they find when they don't think to click a logo
 * (NN/g: a logo that links home is not enough on its own).
 *
 * These pages are on the app host and home is on the marketing one, so the links
 * are HostLinks (ADR-0062).
 *
 * `onLeave(event)` lets a page with unsaved input ask before the visitor goes.
 * Calling `event.preventDefault()` keeps them on the page.
 */
export default function AuthHeader({ subtitle, onLeave }) {
  return (
    <div className="mb-8">
      <HostLink
        to="/"
        onClick={onLeave}
        className="inline-flex items-center gap-1 text-sm text-gray-600 hover:text-brand-500"
      >
        <span aria-hidden="true">←</span> Back to Praenum
      </HostLink>
      <div className="text-center mt-4">
        <h1>
          <HostLink to="/" onClick={onLeave} className="inline-flex items-center justify-center gap-2 group">
            <span
              aria-hidden="true"
              className="flex items-center justify-center w-9 h-9 rounded-lg bg-brand-500 text-white font-bold text-lg"
            >
              P
            </span>
            <span className="text-3xl font-bold text-brand-900 group-hover:opacity-80">Praenum</span>
          </HostLink>
        </h1>
        {subtitle && <p className="text-gray-500 mt-1">{subtitle}</p>}
      </div>
    </div>
  )
}
